"use strict";

import "./Picker.css";
import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";

import Popup from "./../Popup";

export default class Picker extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
		this.createWindowHandlers();
	}
	
	initState() {
		this.state = {
			ready: false,
			x: 0,
			y: 0
		};
	}
	
	createWindowHandlers() {
		this.onWindowResize = this.setPosition.bind(this);
		this.onWindowClick = this.handleClick.bind(this);
	}
	
	componentDidUpdate(prevProps) {
		if (prevProps.shown !== this.props.shown) {
			this.setPosition();
		}
	}
	
	getAnchorElement() {
		return ReactDOM.findDOMNode(this.refs.popup).parentNode || null;
	}
	
	getAnchorRect() {
		if (this.getAnchorElement())
			return this.getAnchorElement().getBoundingClientRect();
		return null;
	}
	
	getSelfElement() {
		return ReactDOM.findDOMNode(this.refs.self);
	}
	
	getSelftRect() {
		return this.getSelfElement().getBoundingClientRect();
	}
	
	setPosition() {
		const anchorY		= this.getAnchorRect().top;
		const anchorX		= this.getAnchorRect().left;
		const anchorWidth	= this.getAnchorRect().width;
		const anchorHeight	= this.getAnchorRect().height;
		const selfWidth		= this.getSelftRect().width;
		const selfHeight	= this.getSelftRect().height;
		const windowHeight	= window.innerHeight;
		const windowWidth	= window.innerWidth;
		
		let x, y;
		
		if (this.props.vertical) {
			x = anchorX + anchorWidth;
			y = anchorY;
			
			if (anchorX + anchorWidth + selfWidth > windowWidth)
				x = anchorX - selfWidth;
			if (anchorY + selfHeight > windowHeight)
				y = anchorY + anchorHeight - selfHeight;
		} else {
			x = anchorX;
			y = anchorY + anchorHeight;
			
			if (anchorY + anchorHeight + selfHeight > windowHeight)
				y = anchorY - selfHeight;
			if (anchorX + selfWidth > windowWidth)
				x = anchorX + anchorWidth - selfWidth;
		}
		
		this.setState({x, y, ready: true});
	}
	
	handleClick(evt) {
		if (!this.props.shown)
			return;
		
		if (!isTargetInElement(evt.target, this.getSelfElement()) &&
			!isTargetInElement(evt.target, this.getAnchorElement())
		) {
			this.props.onWindowClick();
		}
	}
	
	componentDidMount() {
		window.addEventListener("click", this.onWindowClick);
		window.addEventListener("resize", this.onWindowResize);
	}
	
	componentWillUnmount() {
		window.removeEventListener("click", this.onWindowClick);
		window.removeEventListener("resize", this.onWindowResize);
	}
	
	render() {
		
		const popupClassName = classnames({"Invisible": !this.state.ready});
		const className = classnames("Picker", this.props.className);
		
		const style = {
			top: this.state.y + "px",
			left: this.state.x + "px"
		};
		
		return (
			<Popup ref="popup" shown={this.props.shown} className={popupClassName} >
				<div ref="self" className={className} style={style} onClick={evt => evt.stopPropagation()}>
					{this.props.children}
				</div>
			</Popup>
		);
	}
	
}

Picker.propTypes = {
	shown:			React.PropTypes.bool,
	onWindowClick:	React.PropTypes.func,
	vertical:		React.PropTypes.bool
};

Picker.defaultProps = {
	shown: false,
	onWindowClick: () => {},
	vertical: false
};

function isTargetInElement(target, element) {
	let node = target;
	while (node !== null) {
		if (node === element) return true;
		node = node.parentNode;
	}
	return false;
}


// WEBPACK FOOTER //
// ./~/vwa/components/Picker/Picker.jsx